import { qs, listen } from "@fluorescent/dom";
import { prefersReducedMotion } from "@/lib/a11y";

const {
  strings: { accessibility: strings },
} = window.theme;

function featuredVideoHandler(container) {
  const pause = qs(".video-pause-floating", container);
  const video = qs("VIDEO", container);

  if (!pause || !video) return;

  const pauseVideo = () => {
    video.pause();
    pause.dataset.isPlaying = "false";
    pause.title = strings.play_video;
  };

  const playVideo = () => {
    video.play();
    pause.dataset.isPlaying = "true";
    pause.title = strings.pause_video;
  };

  if (prefersReducedMotion()) {
    pauseVideo();
  }

  const pauseListener = listen(pause, "click", e => {
    e.preventDefault();

    if (video.paused) {
      playVideo();
    } else {
      pauseVideo();
    }
  });

  return () => pauseListener();
}

export { featuredVideoHandler };
